export default "__VITE_ASSET__BT6dz6GS__"